import { render, staticRenderFns } from "./PhaseSelector.vue?vue&type=template&id=989b2d24"
import script from "./PhaseSelector.vue?vue&type=script&lang=js"
export * from "./PhaseSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports